import { render, staticRenderFns } from "./RefundIframe.vue?vue&type=template&id=dcb5319e&"
import script from "./RefundIframe.vue?vue&type=script&lang=ts&"
export * from "./RefundIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports